import React from "react";

import { Button } from "../Button";
import TwitterIcon from "../TwitterIcon";
import { useService } from "@/base/hooks/useService";

import { SocialsService } from "@services/SocialsService";
import { StorageService } from "@services/StorageService";

import saveDestination from "../../helpers/saveDestination";

const TwitterLoginButton = (props) => {
  const storageService = useService(StorageService);
  const socialsService = useService(SocialsService);

  const handleLogin = async () => {
    try {
      const response = await socialsService.getTwitterLoginLink();
      saveDestination(storageService);
      const url = response.data.link;
      window.location.href = url.toString();
    } catch (error) {
      console.error("Twitter login error:", error);
    }
  };

  return (
    <Button {...props} onClick={handleLogin}>
      <TwitterIcon className="text-primary-opposite" />
    </Button>
  );
};

export default TwitterLoginButton;
